/* import __COLOCATED_TEMPLATE__ from './metric-stamp.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { JobGroupObject } from 'embercom/components/reporting/automation/ai-insights/fin-insights/jobs';
import type { ReportState } from 'embercom/components/reporting/custom/report/chart-card';
import { staticDataResource } from 'embercom/lib/reporting/static-data-resource';
import { use } from 'ember-resources/util/function-resource';

interface Signature {
  Args: {
    jobGroupObject: JobGroupObject;
    reportState: ReportState;
  };
}

export default class MetricStamp extends Component<Signature> {
  @use dataResource = staticDataResource(this, {
    serializedChart: () => this.countChartDefinition,
    reportState: () => this.args.reportState,
  });

  get countChartDefinition() {
    return {
      visualization_type: 'counter',
      view_by: null,
      chart_series: this.args.jobGroupObject.chartSeries,
    };
  }

  get countValue() {
    return this.dataResource.formatValue({
      value: this.dataResource.kpiData[0],
      metricId: this.args.jobGroupObject.chartSeries[0].metric_id,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinInsights::MetricStamp': typeof MetricStamp;
  }
}
